export default {
  1000: 'Samochód o takim numerze VIN istnieje w systemie',
  1001: 'Samochód posiada aktywną gwarancję w systemie',
  1002: 'Firma o takim numerze NIP istnieje w systemie',
};
